var locale = {
  placeholder: "Sélectionner l'heure"
};
export default locale;
//# sourceMappingURL=fr_FR.js.map
